module.exports = __webpack_public_path__ + "img/u7.9fb1591c.svg";